import request from '@/common/request'

class RelatorioService {
  getByAtualizacaoId(atualizacaoId, tipoRelatorio) {
    return request.get(`/relatorios/${atualizacaoId}/${tipoRelatorio}`)
  }

  generateData(id) {
    return request.patch(`/relatorios/${id}`)
  }

  buscarResumoBasico(atualizacaoId) {
    return request.get(`/relatorios/${atualizacaoId}/extrato`)
  }
}

export default new RelatorioService()
